import * as _ from 'lodash';
import parts from '../../../utilities/parts';
import Joi from 'joi-browser';

import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import regex from '../../../utilities/validateRegex';
import { customValidateDate } from '../../../utilities/validateDateUtil';

/**
 * 作業員登録・更新用パラメータを作成
 * @TODO: 元の仕様によりparam内のプロパティ名がキャメルケースになっていない
 * @param {object}param:登録パラメーター
 * @return {object}registerParam:API通信用登録パラメーター
 * */
const createRegisterWorkerParam = param => {
  const registerParam = Object.create(null);
  if (!isNullOrUndefinedOrEmptyStr(param.name_sei)) {
    registerParam.name_sei = param.name_sei;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.name_mei)) {
    registerParam.name_mei = param.name_mei;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.name_sei_kana)) {
    registerParam.name_sei_kana = param.name_sei_kana;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.name_mei_kana)) {
    registerParam.name_mei_kana = param.name_mei_kana;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.birthday)) {
    registerParam.birthday = param.birthday;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.sex)) {
    registerParam.sex = param.sex;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.ccus_engineer_id)) {
    registerParam.ccus_engineer_id = param.ccus_engineer_id;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.security_code)) {
    registerParam.security_code = param.security_code;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.card_info_expiration_date)) {
    registerParam.card_info_expiration_date = param.card_info_expiration_date;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.company_id)) {
    registerParam.company_id = param.company_id;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.id)) {
    registerParam.worker_id = param.id;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.rank_name_code)) {
    registerParam.rank_name_code = param.rank_name_code.toString();
  }
  return registerParam;
};

/**
 * 作業員削除用パラメータを作成
 * @param {object}param:検索パラメーター
 * @return {object}deleteParam:API通信用削除パラメーター
 * */
const createDeleteWorkerParam = param => {
  const deleteParam = Object.create(null);
  if (!isNullOrUndefinedOrEmptyStr(param) && param.length > 0) {
    deleteParam.workers = _.map(param, worker => {
      if (parts.inProperty(worker, 'id')) {
        return { worker_id: Number(worker.id) };
      }
    });
  }
  return deleteParam;
};

/**
 * CCUS技能者情報再取得開始API用パラメータを作成
 * @param {object}workerId:作業員ID
 * @param {object}companyId:企業ID
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createRefetchCcusWorkerInfoParam = (workerId, companyId) => {
  const searchParam = Object.create(null);
  if (!isNullOrUndefinedOrEmptyStr(workerId)) {
    searchParam.worker_id = workerId;
  }
  if (!isNullOrUndefinedOrEmptyStr(companyId)) {
    searchParam.company_id = companyId;
  }
  return searchParam;
};

/**
 * CCUS技能者情報再取得開始API用パラメータを作成
 * @param {object}param:検索パラメーター
 * @return {object}deleteParam:API通信用検索パラメーター
 * */
const createCcusMonitoringParam = param => {
  const monitoringParam = Object.create(null);
  if (!isNullOrUndefinedOrEmptyStr(param.ccusStateManagementsId)) {
    monitoringParam.ccus_state_managements_id = param.ccusStateManagementsId;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.ccusEngineerId)) {
    monitoringParam.ccus_engineer_id = param.ccusEngineerId;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.companyId)) {
    monitoringParam.company_id = param.companyId;
  }
  if (!isNullOrUndefinedOrEmptyStr(param.workerId)) {
    monitoringParam.worker_id = param.workerId;
  }
  monitoringParam.ccus_worker_data_fetch_flg = param.ccusWorkerDataFetchFlg;
  return monitoringParam;
};

/**
 * バリデーション用のスキーマを作成する
 * @return {object}validateSchema:バリデーション用のスキーマ
 * */
const createValidateSchema = () => {
  const validateSchema = Object.create(null);
  validateSchema.id = Joi.number().allow(null, '');
  validateSchema.name_sei = Joi.string()
    .trim()
    .required()
    .max(255);
  validateSchema.name_mei = Joi.string()
    .trim()
    .required()
    .max(255);
  validateSchema.name_sei_kana = Joi.string()
    .label('intAndKatakana')
    .regex(regex.pattern.intAndKatakana)
    .required()
    .max(255);
  validateSchema.name_mei_kana = Joi.string()
    .label('intAndKatakana')
    .regex(regex.pattern.intAndKatakana)
    .required()
    .max(255);
  validateSchema.sex = Joi.string().required();
  validateSchema.birthday = customValidateDate
    .base()
    .validateDate()
    .requiredDate()
    .required();
  validateSchema.ccus_engineer_id = Joi.string()
    .label('int')
    .regex(regex.pattern.integerNoSign)
    .length(14)
    .allow(null, '');
  validateSchema.security_code = Joi.string()
    .label('int')
    .regex(regex.pattern.integerNoSign)
    .length(4)
    .allow(null, '');
  validateSchema.card_info_expiration_date = customValidateDate
    .base()
    .validateDate();
  return validateSchema;
};

/**
 *
 * */
const WorkersService = {
  createRegisterWorkerParam,
  createDeleteWorkerParam,
  createRefetchCcusWorkerInfoParam,
  createCcusMonitoringParam,
  createValidateSchema,
};

export default WorkersService;



// WEBPACK FOOTER //
// ./src/services/workers/workerInfo/WorkerInfoService.js